var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 19V18.1875C4.5 16.2986 4.88889 14.7674 5.66667 13.5938C6.44444 12.4201 7.51389 11.2222 8.875 10C7.51389 8.77778 6.44444 7.57986 5.66667 6.40625C4.88889 5.23264 4.5 3.70139 4.5 1.8125V1H6V2.15625C6 2.27431 6.00694 2.38889 6.02083 2.5H13.9792C13.9931 2.38889 14 2.27431 14 2.15625V1H15.5V1.8125C15.5 3.70139 15.1111 5.23264 14.3333 6.40625C13.5556 7.57986 12.4861 8.77778 11.125 10C12.4861 11.2222 13.5556 12.4201 14.3333 13.5938C15.1111 14.7674 15.5 16.2986 15.5 18.1875V19H14V17.8438C14 17.7257 13.9931 17.6111 13.9792 17.5H6.02083C6.00694 17.6111 6 17.7257 6 17.8438V19H4.5ZM6.89583 5.5H13.1042C13.2431 5.26389 13.3646 5.02431 13.4688 4.78125C13.5729 4.53819 13.6597 4.27778 13.7292 4H6.27083C6.34028 4.27778 6.42708 4.53819 6.53125 4.78125C6.63542 5.02431 6.75694 5.26389 6.89583 5.5ZM10 9C10.3889 8.65278 10.7569 8.31597 11.1042 7.98958C11.4514 7.66319 11.7708 7.33333 12.0625 7H7.9375C8.22917 7.33333 8.54514 7.66319 8.88542 7.98958C9.22569 8.31597 9.59722 8.65278 10 9ZM7.9375 13H12.0625C11.7708 12.6667 11.4514 12.3368 11.1042 12.0104C10.7569 11.684 10.3889 11.3472 10 11C9.59722 11.3472 9.22569 11.684 8.88542 12.0104C8.54514 12.3368 8.22917 12.6667 7.9375 13ZM6.27083 16H13.7292C13.6597 15.7222 13.5694 15.4618 13.4583 15.2188C13.3472 14.9757 13.2222 14.7361 13.0833 14.5H6.89583C6.75694 14.7361 6.63542 14.9757 6.53125 15.2188C6.42708 15.4618 6.34028 15.7222 6.27083 16Z",
    fill: "#5A2810"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile15);
export default __webpack_public_path__ + "static/media/profile-15.c58d72be2f53c8b9b1f637187a6a7691.svg";
export { ForwardRef as ReactComponent };